import React from "react";
import TableCell from "../../common/ui/TableCell";
import TinyMCEpreview from "../../const/TinyMCEpreview";

export default function ReportView({ doc }) {
  const meta = doc?.meta || {};

  // ✅ 공통 필드(문서 번호/현장명/작성자/작성일/문서 제목/첨부자료)는 FormViewManager에서 이미 렌더링하므로 여기서는 제외
  const version = meta.version || "-";
  const note = meta.note || "-";
  const formType = doc?.doc_type || "-";
  // const statusLabel =
  //   doc?.status === "approved"
  //     ? "승인"
  //     : doc?.status === "draft"
  //     ? "임시저장"
  //     : doc?.status === "rejected"
  //     ? "반려"
  //     : doc?.status === "submit"
  //     ? "상신 완료"
  //     : "진행 중";

  // 작성 화면(PlanEditor)의 상태 표기(임시저장/승인/진행중)에 맞춰 통일
  const statusLabel = (() => {
    const s = doc?.status || meta?.status || "none";
    if (s === "draft") return "임시저장";
    if (s === "approved") return "승인";
    if (s === "rejected") return "반려";
    if (s === "submit") return "상신";
    if (s === "cancel") return "취소";
    if (s === "none") return "-";
    return "진행중";
  })();

  const section = "rounded-2xl border bg-white p-4";
  const sectionStyle = {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  };

  return (
    <div
      className="w-full px-2 space-y-3 text-sm text-gray-800 min-w-0 overflow-x-hidden"
      style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
    >
      {/* 기본정보 */}
      <section className={section} style={sectionStyle}>
        <div
          className="space-y-2 min-w-0"
          style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
        >
          <div
            className="flex items-start gap-2 min-w-0"
            style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
          >
            <div
              className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
              style={{ fontSize: "0.75rem" }}
            >
              버전
            </div>
            <div
              className="flex-1 min-w-0 text-xs text-gray-900 truncate"
              style={{
                fontSize: "0.75rem",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >{`v${version}`}</div>
          </div>
          <div
            className="flex items-start gap-2 min-w-0"
            style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
          >
            <div
              className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
              style={{ fontSize: "0.75rem" }}
            >
              상태
            </div>
            <div
              className="flex-1 min-w-0 text-xs text-gray-900 truncate"
              style={{
                fontSize: "0.75rem",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {statusLabel}
            </div>
          </div>
          <div
            className="flex items-start gap-2 min-w-0"
            style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
          >
            <div
              className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium align-top"
              style={{ fontSize: "0.75rem" }}
            >
              비고
            </div>
            <div
              className="flex-1 min-w-0 text-xs text-gray-900"
              style={{ fontSize: "0.75rem", wordBreak: "break-word" }}
            >
              <TinyMCEpreview
                html={
                  note && note !== "-"
                    ? note
                    : "<p class='text-gray-400 italic'>비고 내용이 없습니다.</p>"
                }
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
